export default "__VITE_ASSET__BaZ1ct0V__"